import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Form, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../../config";
import ExportExcel from "../../../utility/ExportCSV";
import enableTableSearch from "../../../utility/tableSearch";
import { authFetch } from "../../../utility/authFetch";

function ProblemTable({ onEdit, reload }) {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const tableRef = useRef();
  const inputRef = useRef();

  // 🔹 Fetch data from API
  useEffect(() => {
    const fetchProblems = async () => {
      try {
        const response = await authFetch(`${API_BASE_URL}/api/problems`);
        const result = await response.json();
        setData(result.problems || []);
      } catch (error) {
        console.error("Error fetching problems:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProblems();
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No problem found",
    });

    return cleanup;
  }, [loading]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <ExportExcel tableId="ProblemTable" filename="problems_report.xlsx" />
        <Form.Control
          type="text"
          placeholder="Search"
          style={{ width: "200px" }}
          name="search"
          id="search"
          ref={inputRef}
        />
      </div>

      {loading ? (
        <div className="text-center py-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Table striped bordered hover id="ProblemTable" ref={tableRef}>
          <thead>
            <tr>
              <th style={{ width: "100px" }}>Action</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="2" className="text-center">
                  No records found
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Button variant="warning" onClick={() => onEdit(item)}>
                      EDIT
                    </Button>
                  </td>
                  <td>{item.name}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </>
  );
}

export default ProblemTable;
